import styled from 'styled-components';

export const WrapperForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .linha-filtros {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
  }

  .field-date {
    flex: 0 1 210px;
    min-width: 190px;
  }

  .field-radio {
    flex: 0 0 auto;
    min-width: 190px;
  }

  .field-autocomplete {
    flex: 1 1 160px;
    min-width: 160px;
  }

  .field-select {
    flex: 0 1 170px;
    min-width: 150px;
  }

  .row-botoes {
    width: auto;
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: flex-start;
    align-items: center;
    margin-top: 1.6rem;
  }

  @media (max-width: 768px) {
    .field-date,
    .field-radio,
    .field-autocomplete,
    .field-select {
      flex: unset;
      width: 100%;
    }

    .row-botoes {
      width: 100%;
      margin-top: 0;
    }
  }
`;
